import jquery from 'jquery';
import EFOcats_event_core from '../../../core/v1/event/efocats_event_core.js';

/**
 * ページ離脱前イベント
 */
export default class EFOcats_event_before_leave extends EFOcats_event_core {
  /**
   * イベントための事前の仕込み
   */
  init() {
    // 処理なし
  }

  /**
   * イベント本体をセット
   */
  event() {
    jquery(window).on('beforeunload.attention', () => {
      if (efocats.open_modal) {
        return 'このページから移動しますか？ 入力したデータは保存されません。';
      }

      return undefined;
    });
  }
}
